import { RootState } from "@store/index";
import { createSelector } from "@reduxjs/toolkit";

const incomeStateSelector = (state: RootState) =>
  state.viewShipping?.incomeStatement;

export const manageServices = createSelector(
  [incomeStateSelector],
  (incomeStatement) => incomeStatement.manageServices,
);

export const manageServicesItems = createSelector(
  [manageServices],
  (manageServices) => manageServices.services.items,
);

export const manageServicesLoading = createSelector(
  [manageServices],
  (manageServices) => manageServices.services.loading,
);

export const addAssignmentModalSelector = createSelector(
  [incomeStateSelector],
  (incomeStatement) => incomeStatement.addAssignmentModal,
);

export const selectModifyPriceUiState = (state: RootState) => {
  const cancel =
    state.viewShipping.incomeStatement.cancelShippingCasesByPricesId;
  const modify = state.viewShipping.incomeStatement.modifySelectedServicePrice;
  const edit = state.viewShipping.incomeStatement.editShippingCasesByPricesId;

  return {
    success: cancel.success || modify.success || edit.success,
    error: cancel.error || modify.error || edit.error,
    loading: cancel.loading || modify.loading || edit.loading,
  };
};

export const selectISErrorState = (state: RootState) => {
  const invoice = state.viewShipping.incomeStatement.invoice;
  const services = state.viewShipping.incomeStatement.manageServices.services;

  return {
    success: invoice.success || services.success,
    error: invoice.error || services.error,
  };
};
